<template>
  <div class="app-container">
    <basic-container>
      <div class="operation">
        <el-button @click="cancel" size="medium">取消</el-button>
        <el-button size="medium" type="primary" v-if="!isEdit" @click="onSubmit('sizeForm')">保存</el-button>
        <el-button size="medium" type="primary" v-if="isEdit" @click="onEditSubmit('sizeForm')">保存</el-button>
      </div>
      <el-form ref="sizeForm" class="sizeForm" :model="sizeForm" label-width="100px" size="medium" :rules="rules">
        <el-row gutter="20">
          <el-form-item label="主题" prop="subject">
            <el-input v-model="sizeForm.subject" placeholder="请输入主题"></el-input>
          </el-form-item>
          
          <el-form-item label="类型" prop="type">
            <el-select v-model="sizeForm.type" :disabled="!isNotPublish" @change="typeChange" placeholder="请选择投票类型">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input :rows="5" type="textarea" placeholder="请选择输入内容" v-model="sizeForm.description"></el-input>
          </el-form-item>
          <el-form-item label="参与范围" prop="votePermissionList">
            <el-form-item>
              <el-select :disabled="!isNotPublish" v-model="sizeForm.votePermissionList" multiple filterable placeholder="请选择标签" @change="onVotePermissionChange">
                <el-option
                  v-for="item in tagList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.value !== allUserPermissionTag.value && isAllUserParticipant">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 分组，多条件权限（暂时不用，不做复杂权限） TODO：编辑时默认选中 -->
            <!-- <el-button size="small" type="primary" @click="onClickAddPermission">添加分组</el-button>
            <div class="permission" v-for="(permission, permissionIndex) in sizeForm.permissions" :key="permissionIndex">
                <el-row :gutter="20" v-for="(condition, conditionIndex) in permission.conditions" :key="conditionIndex">
                    <el-col :span="11" class="permission-group">
                      <el-form-item :prop="'permissions.' + permissionIndex + '.conditions.' + conditionIndex + '.filterType'" :rules="[{ required: true, message: '请选择筛选条件', trigger: 'change' }]">
                        <el-select v-model="condition.filterType" placeholder="筛选条件">
                          <el-option
                            v-for="(item, index) in filterTypes"
                            :key="index"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item :prop="'permissions.' + permissionIndex + '.conditions.' + conditionIndex + '.tagIds'" :rules="[{ required: true, message: '请选择标签', trigger: 'change' }]">
                        <el-select v-model="condition.tagIds" multiple filterable placeholder="请选择标签">
                          <el-option
                            v-for="item in sizeForm.votePermissionList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="2">
                      <el-button size="medium"
                            type="text"
                            icon="el-icon-close"
                            @click="onClickRemoveCondition(permissionIndex, conditionIndex)">
                      </el-button>
                    </el-col>
                </el-row>
                <div v-if="!!sizeForm.permissions[permissionIndex].conditions[0]">
                  <el-button size="small" type="danger" @click="onClickRemovePermission(permissionIndex)">删除分组</el-button>
                  <el-button size="small" type="primary" @click="onClickAddCondition(permissionIndex)">添加条件</el-button>
                </div>
            </div> -->
          </el-form-item>
          <el-form-item label="收集方式" prop="collectType">
            <el-select v-model="sizeForm.collectType" :disabled="!isNotPublish" placeholder="请选择投票收集方式">
              <el-option v-for="item in collectTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="投票选项" required>
            <el-row gutter="20" class="vote-option-row" type="flex" justify="space-between" v-for="(item, index) in sizeForm.voteOptionList" :key="index">
              <el-col :span="24">
                <el-form-item :prop="'voteOptionList.' + index + '.content'" :rules="[
                  { type: 'string', required: true, message: '请输入选项标题', trigger: 'blur' },
                  { max: 30, message: '不超过30个', trigger: 'blur' }
                ]">
                  <el-input v-model="item.content" maxlength="30" :placeholder="'选项标题' + (index + 1)"></el-input>
                </el-form-item>
                <el-form-item :prop="'voteOptionList.' + index + '.description'" :rules="[
                  { required: false, max: 120, message: '不超过120个', trigger: 'blur'}
                ]">
                  <el-input v-if="isPicType" :rows="3" type="textarea" placeholder="请输入内容" v-model="item.description" class="option-desc"></el-input>
                </el-form-item>
                <el-form-item :prop="'voteOptionList.' + index + '.url'">
                  <el-input v-if="isPicType" :rows="1" type="text" placeholder="请输入详情链接" v-model="item.url" class="option-url"></el-input>
                </el-form-item>
                <el-form-item class="img-box" v-if="isPicType" :prop="'voteOptionList.' + index + '.imageUrl'" :rules="[
                  { required: true, message: '请上传选项图片', trigger: 'change'}
                ]">
                  <img :ref="'imageUrlOptions' + index" class="image-url-options" v-show="item.imageUrl" :src="item.imageUrl">
                  <div class="upload-btn">
                    <el-button @click="handleImageChange(index)" size="small" type="primary">{{isEdit && item.voteId || isUploadSuccess[index] ? '重新上传' : '点击上传'}}</el-button>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-button type="danger" icon="el-icon-remove-outline" :disabled="sizeForm.voteOptionList.length === 2" @click="optionDel(index, item)"></el-button>
                <el-button :disabled="index === 0" type="primary" icon="el-icon-upload2" @click="moveUp(index)"></el-button>
              </el-col>
            </el-row>
            <el-button type="primary" icon="el-icon-circle-plus-outline" v-if="!isEdit" @click="optionAdd(index)">添加</el-button>
          </el-form-item>
          <el-form-item label="拥有票数" prop="voteCount">
            <el-input-number :disabled="!isNotPublish" @keyup.native="numberCheck" v-model="sizeForm.voteCount" controls-position="right" @change="handleChange" :min="1" :max="getNumLen"></el-input-number>
          </el-form-item>
          <!-- <el-form-item label="是否多选" prop="isMultiple" v-if="isTextType">
            <el-switch :disabled="!isNotPublish" v-model="sizeForm.isMultiple"></el-switch>
          </el-form-item>
          <el-form-item label="最多选择" v-if="sizeForm.isMultiple">
            <el-input-number :disabled="!isNotPublish" v-model="sizeForm.voteCount" controls-position="right" @change="handleChange" :min="2" :max="getNumLen"></el-input-number>
          </el-form-item> -->
          <!-- <el-form-item label="票数显示">
            <el-col :span="12">
              <el-radio-group v-model="radio">
                <el-radio :label="0">投票数</el-radio>
                <el-radio :label="1">百分比</el-radio>
                <el-radio :label="2">全显示</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>  -->
          <el-form-item label="开始时间" prop="startTime">
            <el-col :span="13" class="start-time-col">
              <el-date-picker
                :disabled="isEdit && sizeForm.statusEnum === statusOptions[1].value"
                v-model="sizeForm.startTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
                align="right"
                default-time="00:00:00"
                :picker-options="pickerOptionsStart">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime">
            <el-col :span="13" class="end-time-col">
              <el-date-picker
                v-model="sizeForm.endTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
                align="right"
                default-time="23:59:59"
                :picker-options="pickerOptionsEnd">
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
    </basic-container>
  </div>
</template>
<script>
import { getOrganizationTag, createVote, getVoteDetail, voteEdit } from '@/api/app/vote';
import { typeOptions, collectTypeOptions, filterTypes, statusOptions } from '@/const/crud/app/vote';
import { getFileKeyAsync } from '@/util/util'
import { getOSSVote } from '@/api/basic/aliyunoss';
import uploadService from '@/common/common-logic/upload-service';
import moment from 'moment';
export default {
  
  data() {
    const validateTime = (rule, value, callback) => {
      if(moment(this.sizeForm.endTime).diff(moment(this.sizeForm.startTime)) <= 0) {
        callback(new Error('开始时间必须小于结束时间！'));
      } else {
        callback();
      }
    };
    return {
      typeOptions,
      collectTypeOptions,
      filterTypes,
      statusOptions,
      sizeForm: {
        subject: '',
        type: '',
        collectType: '',
        description: '',
        startTime: '',
        endTime: '',
        isMultiple: false,
        voteCount: 1,
        voteOptionList: [{
          content: '',
          description: '',
          url: '',
          imageUrl: '',
          sort: 0
        },{
          content: '',
          description: '',
          url: '',
          imageUrl: '',
          sort: 1
        }],
        deleteVoteOptionIdList: [],
        votePermissionList: [],
        statusEnum: statusOptions[0].value,
      },
      isAllUserParticipant: false,
      allUserPermissionTag: {
        label: '全部用户',
        value: -1,
      },
      id: '',
      isEdit: false,
      tagList: [],
      isUploadSuccess: [],
      rules: {
        subject: [
          { type: 'string', required: true, message: '请输入主题', trigger: 'blur' },
          { max: 256, message: '不超过256个', trigger: 'blur' }
        ],
        type: [
          { type: 'string', required: true, message: '请选择类型', trigger: 'change' }
        ],
        collectType: [
          { type: 'string', required: true, message: '请选择收集类型', trigger: 'change' }
        ],
        description: [
          { type: 'string', required: true, message: '请输入内容', trigger: 'blur' },
          { max: 512, message: '不超过512个', trigger: 'blur' }
        ],
        votePermissionList: [
          { type: 'array', required: true, message: '请选择参与范围', trigger: 'blur' },
        ],
        voteCount: [
          { type: 'number', required: true, message: '请输入拥有票数', trigger: 'blur' },
        ],
        startTime: [
          { type: 'string', required: true, message: '请选择开始时间', trigger: 'change' },
          { validator: validateTime, trigger: 'change' }
        ],
        endTime: [
          { type: 'string', required: true, message: '请选择结束时间', trigger: 'change' },
          { validator: validateTime, trigger: 'change' }
        ]
      }
    };
  },
  watch: {
    getStartTime: {
      handler(v) {
        if(this.sizeForm.endTime) {
          this.$refs['sizeForm'].validateField('endTime')
        }
      }
    },
    getEndTime: {
      handler(v) {
        if(this.sizeForm.startTime && !this.isEdit) {
          this.$refs['sizeForm'].validateField('startTime')
        }
      }
    },
    getIsMultiple(val) {
      if (!val) {
        this.typeChange();
      }
    },
  },
  computed: {
    getNumLen() {
      return this.sizeForm.voteOptionList.length;
    },
    isTextType() {
      return this.sizeForm.type === typeOptions[0].value;
    },
    isPicType() {
      return this.sizeForm.type === typeOptions[1].value;
    },
    isNotPublish() {
      return this.sizeForm.statusEnum === statusOptions[0].value;
    },
    isProgressing() {
      return this.sizeForm.statusEnum === statusOptions[1].value;
    },
    getStartTime() {
        return this.sizeForm.startTime;
    },
    getEndTime() {
        return this.sizeForm.endTime;
    },
    getIsMultiple() {
      return this.sizeForm.isMultiple;
    },
  },
  mounted() {
    let _this = this;
    _this.tagList.push(_this.allUserPermissionTag);
  },
  created() {
    this.clearValidate();
    this.getOrganizationTag();
    this.id = this.$route.params.id;
    if(this.id) {
      this.isEdit = true;
      this.getDetail();
    }
  },
  methods: {
    typeChange() {
      this.sizeForm.voteOptionList.forEach((v) => v.imageUrl = '');
      this.sizeForm.isMultiple = false;
      this.sizeForm.voteCount = 1;
    },
    numberCheck(){
      this.sizeForm.voteCount = this.sizeForm.voteCount.replace(/[^\.\d]/g,'');
      this.sizeForm.voteCount = this.sizeForm.voteCount.replace('.','');
    },
    optionDel(index, voteOption) {
      if(this.sizeForm.voteOptionList.length === 2) return;
      if(this.sizeForm.voteCount === this.sizeForm.voteOptionList.length)
        this.sizeForm.voteCount--;
      this.sizeForm.voteOptionList.splice(index, 1);
      if (voteOption.voteId) {
        this.sizeForm.deleteVoteOptionIdList.push(item.id);
      }
    },
    optionAdd() {
      this.sizeForm.voteOptionList.push({
        content: '',
        description: '',
        url: '',
        imageUrl: '',
        sort: this.sizeForm.voteOptionList.length
      });
      this.isUploadSuccess[this.sizeForm.voteOptionList.length] = null;
      this.$message({
        message: '增加一项成功',
        type: 'success'
      })
    },
    moveUp(index){
      if (index > 0) {
        let tempOption = this.sizeForm.voteOptionList[index - 1];
        this.$set(this.sizeForm.voteOptionList, index - 1, this.sizeForm.voteOptionList[index]);
        this.$set(this.sizeForm.voteOptionList, index, tempOption)
        let temp;
        temp = this.sizeForm.voteOptionList[index - 1].sort;
        this.sizeForm.voteOptionList[index - 1].sort = this.sizeForm.voteOptionList[index].sort;
        this.sizeForm.voteOptionList[index].sort = temp;
        this.$message({
          message: '上移成功',
          type: 'success'
        })
      }
    },
    onClickAddCondition(permissionIndex) {
      this.sizeForm.permissions[permissionIndex].conditions.push({});
      this.clearValidate();
    },
    onClickAddPermission() {
      this.sizeForm.permissions.push({
        conditions: [{}],
      });
      this.clearValidate();
    },
    onClickRemoveCondition(permissionIndex, conditionIndex) {
      this.sizeForm.permissions[permissionIndex].conditions.splice(conditionIndex, 1);
    },
    onClickRemovePermission(permissionIndex) {
      this.sizeForm.permissions.splice(permissionIndex, 1);
    },
    onVotePermissionChange(tagIds) {
      let _this = this;
      if (tagIds.includes(_this.allUserPermissionTag.value)) {
        _this.sizeForm.votePermissionList = [_this.allUserPermissionTag.value];
        _this.isAllUserParticipant = true;
      } else {
        _this.isAllUserParticipant = false;
      }
    },
    getOrganizationTag() {
      let _this = this;
      getOrganizationTag().then(res => {
        if(res.data.code === 0 && res.data.data){
          for(let item of res.data.data) {
            _this.tagList.push({ label: item.tagName, value: item.id });
          }
        }
      }).catch(error => {
        this.$message({
          message: '获取标签失败',
          type: 'error'
        })
      })
    },
    async handleImageChange (index) {
      this.$openMaterialLib((list) => {
        if (!list || list.length === 0) {
          return;
        }
        this.isUploadSuccess[index] = list[0].contentUrl
        this.sizeForm.voteOptionList[index].imageUrl = list[0].contentUrl
      }, 1);
    },
    getParams () {
      return {
        ...this.sizeForm,
        votePermissionList: this.formatPermissions(this.sizeForm.votePermissionList),
      }
    },
    cancel () {
      this.$router.$avueRouter.closeTag()
      this.$router.go(-1)
    },
    handleChange(val) {
      if(val > this.getNumLen) {
        this.sizeForm.voteCount = this.getNumLen;
      }
    },
    onSubmit(formName) {
      const params = this.getParams();
      if (this.isPicType && params.voteCount > 1) {
        params.isMultiple = true;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          createVote(params).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '创建成功',
                type: 'success'
              })
              this.$router.$avueRouter.closeTag()
              this.$router.push({
                path: `/app/vote`,
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          }).catch(err => {
            this.$message({
              message: err,
              type: 'error'
            })
          })
        } else {
          this.$message({
            message: '请通过验证',
            type: 'error'
          })
          return false;
        }
      });
    },
    clearValidate() {
      // 解决页面渲染时触发select change验证的问题
      this.$nextTick(()=>{
        this.$refs['sizeForm'].clearValidate();
      })
    },
    getDetail() {
      getVoteDetail(this.id).then(res => {
        this.sizeForm = this.formatDetail(res.data.data);
      }).catch(error => {
        this.$message({
          message: '获取投票详情失败',
          type: 'error'
        })
      })
    },
    formatPermissions(data) {
      let res = []
      if (!data.includes(-1)) {
        data.forEach((element, index) => {
          res.push({ groupIndex: index, tagId: element })
        });
      }
      return res;
    },
    formatDetail(data) {
      let arr = []
      let _this = this;
      data.votePermissionList.forEach(element => {
        arr.push(element.tagId)
      });
      if (arr.length === 0) {
        arr.push(_this.allUserPermissionTag.value);
        _this.isAllUserParticipant = true;
      }
      data.votePermissionList = arr;
      return data;
    },
    onEditSubmit(formName) {
      const params = this.getParams();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          voteEdit(params).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '编辑成功',
                type: 'success'
              })
              this.$router.$avueRouter.closeTag()
              this.$router.push({
                path: `/app/vote`,
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          }).catch(err => {
            this.$message({
              message: err,
              type: 'error'
            })
          })
        } else {
          this.$message({
            message: '请通过验证',
            type: 'error'
          })
          return false;
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
  .operation {
    text-align: right;
  }
  .sizeForm{
    width: 650px;
  }
  .vote-option-row{
    margin-bottom: 15px;
    .image-url-options{
      width: 148px;
      height: 148px;
      border-radius: 6px;
      margin-right: 8px;
      float: left;
      object-fit: cover;
    }
  }
  .upload-btn {
    display: flex;
    width: 148px;
    height: 148px;
    border: 3px #E4E7ED dashed;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: center;
    align-content: center;
  }
  .permission{
    margin-top: 10px;
  }
  .option-desc{
    margin: 20px 0 0 0;
  }
  .option-url{
    margin: 20px 0 0 0;
  }
  .permission-group{
    margin-bottom: 20px;
  }
  .start-time-col, .end-time-col{
    padding: 0 !important;
    margin: 0 !important;
  }
  .img-box{
    margin-top: 20px;
  }
</style>
